<div class="content">
  <div class="instructions">
    <label class="instructionLabel">
      Please use the buttons on the right to move the items in the desired order and click the save button to update the
      loop
    </label>
  </div>
  @if (unitSelections) {
    <div class="inputRow">
      <div class="listContainer">
        <select class="selectionList" size="10" [(ngModel)]="selectedUnitId">
          @for (unit of unitSelections; track unit) {
            <option class="listItem" [value]="unit.id">
              {{ unit.description }}
            </option>
          }
        </select>
      </div>
      <div class="movementButtonContainer">
        <button matButton="text" class="movementButton" [disabled]="!canMoveUp()" (click)="moveToTop()">
          <span>
            <mat-icon class="size-16">vertical_align_top</mat-icon>
            <label class="buttonLabel">Top</label>
          </span>
        </button>
        <button matButton="text" class="movementButton" [disabled]="!canMoveUp()" (click)="moveUp()">
          <span>
            <mat-icon class="size-16">arrow_upward</mat-icon>
            <label class="buttonLabel">Up</label>
          </span>
        </button>
        <button matButton="text" class="movementButton" [disabled]="!canMoveDown()" (click)="moveDown()">
          <span>
            <mat-icon class="size-16">arrow_downward</mat-icon>
            <label class="buttonLabel">Down</label>
          </span>
        </button>
        <button matButton="text" class="movementButton" [disabled]="!canMoveDown()" (click)="moveToBottom()">
          <span>
            <mat-icon class="size-16">vertical_align_bottom</mat-icon>
            <label class="buttonLabel">Bottom</label>
          </span>
        </button>
      </div>
    </div>
  }
  <div class="buttonRow">
    <span class="spacer"></span>
    <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Cancel</label>
      </span>
    </button>
    <button class="dialogButton primary-button" matButton="elevated" (click)="save()">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Save</label>
      </span>
    </button>
  </div>
</div>
